module.exports = __webpack_public_path__ + "img/hxbutton.5719de24.png";